import { lazy } from 'react';

import Home from './components/Home';
const Users = lazy(() => import('./components/Users'));
const UserProfile = lazy(() => import('./components/UserProfile'));
const SearchUser = lazy(() => import('./components/SearchUser'));
const Login = lazy(() => import('./components/Login'));
const AuthProfile = lazy(() => import('./components/AuthProfile'));
const About = lazy(() => import('./components/About'));
const RepoDetail = lazy(() => import("./components/RepoDetail"));
const NotFound = lazy(() => import('./components/NotFound'));

export const appRoutes = [
    {
        path: 'https://www.mrhussain.in/portfolio/github-explore/',
        component: Home,
        requiresAuth: false
    },
    {
        path: 'https://www.mrhussain.in/portfolio/github-explore/users',
        component: Users,
        requiresAuth: false
    },
    {
        path: 'https://www.mrhussain.in/portfolio/github-explore/authprofile/:username',
        component: AuthProfile,
        requiresAuth: true
    },
    {
        path: 'https://www.mrhussain.in/portfolio/github-explore/search',
        component: SearchUser,
        requiresAuth: false
    },
    {
        path: 'https://www.mrhussain.in/portfolio/github-explore/login',
        component: Login,
        requiresAuth: false
    },
    {
        path: 'https://www.mrhussain.in/portfolio/github-explore/users/user/:username',
        component: UserProfile,
        requiresAuth: false
    },
    {
        path: 'https://www.mrhussain.in/portfolio/github-explore/about',
        component: About,
        requiresAuth: false
    },
    {
        path: "https://www.mrhussain.in/portfolio/github-explore/repo-detail/:name/:username",
        component: RepoDetail,
        requiresAuth: false,
    },
    {
        path: '*',
        component: NotFound,
        requiresAuth: false
    }
]